<template>
<div id="dealer-search" style="width:100%;">

  <contact-confirmation :confirmed="'true'" :error="'false'"></contact-confirmation>

  <modal name="contact-email-form" id="vehicle-description" width="96%" :max-width="800" height="auto" :adaptive="true"  :reset="true" :scrollable="true">
    <div class="ui modal-content">
        <div slot="top-right" style="text-align:right;">
          <button class="ui icon button" @click="closeContactForm()"><i class="times icon"></i></button>
        </div>

      <div slot="top-left" style="text-align:left; padding-left:15px;margin-top:-10px;">
        <h2 style="color:#000000;">{{$t('Kontakt')}}</h2>
      </div>
      <div class="row" style="padding:15px;">
      <div  class="col-md-16">
        <div>
          <contact-steps :step="step" :lang="lang" @backToStepOne="backToStepOne()"></contact-steps>
          <br>
        </div>
        <div v-if="step == 0" slot="top-left">
          <contact-subject-selection :settings="settings" :lang="lang" @subjectSelected="setSubject($event)"></contact-subject-selection>
        </div>
        <div v-if="step == 1 || step == 2">
          <contact-form :setting="formsetting" :lang="lang" :privacy="config.privacy"  @requestResponseState="requestResponseState($event)">  </contact-form>
        </div>
      </div>

      <div class="col-md-8">
        <div class="ce-textpic ce-right ce-intext" style="background-color:#F3F4F5; padding:8px;">

		<div class="ce-bodytext" v-html="info">

		</div>


	</div>
      </div>
    </div>

  </div>
  </modal>

</div>
</template>

<script>


//const topics = [{id:0, name:'Allgemein'}, {id:1, name:'Vermietung'},{id:2, name:'Verkauf'},{id:3, name:'Service'}];

import PrepareFilter from './utils/PrepareFilter'
import Config from './Config';
import {
  i18n
}
from './plugins/i18n.js'
import {
  mapState,
} from 'vuex'

export default {
  name: 'app',
  components: {
    'contact-form': () => import('./components/sections/ContactForm'),
    'contact-steps': () => import('./components/sections/Steps'),
    'contact-subject-selection': () => import('./components/sections/SubjectSelection'),
    'contact-confirmation': () => import('./components/sections/ContactConfirmation'),
  },
  data: function() {
    return {
      user: {},
      loaded: true,
      from: null,
      searchstring: null,
      mfilter: {},
      config: Config,
      selectedDealer: null,
      lang: 'de'
    }
  },
  computed: {
    settings() {
      return this.$store.state.summery.settings;
    },
    step() {
      return this.$store.state.summery.step;
    },
    formsetting() {
      return this.$store.state.summery.formsetting;
    },
    info() {
      return this.$store.state.summery.info;
    },
  },
  created: function() {

    this.$store.commit('summery/step', 0);


    const mountEl = document.querySelector('#rewaco-contact');



    if (mountEl && mountEl.dataset){


    if(mountEl.dataset['lang'] != undefined) {
      //let languages = ['de', 'en', 'fr'];
      i18n.locale = mountEl.dataset['lang'];
      this.lang = mountEl.dataset['lang'];
    } else {
        i18n.locale = 'de';
    }


    if (mountEl.dataset.sec != null) {
      this.user.sec = mountEl.dataset.sec;
    }
  }

  /*
  var pathArray = window.location.pathname.split('/');
  var secondLevelLocation = pathArray[1];


    if (secondLevelLocation == "de" || secondLevelLocation == "en" || secondLevelLocation == "fr") {
      i18n.locale = secondLevelLocation;
    } else {
      i18n.locale = "de";
    }
    */

    setTimeout( () => {
        //this.$modal.show('contact-email-form')
    }, 10);

    this.loaded = true;
  },
  methods: {

    setSubject: function(index){

      this.$store.commit('summery/formsetting', this.settings[index]);
this.$store.commit('summery/step', 1);

    },
    backToStepOne: function(){
      this.$store.commit('summery/step', 0);
    },
    requestResponseState: function(state){
      this.$store.commit('summery/step', 2);
    },
    openContactForm: function(topic=-1){

      console.log("TOPIC", topic);

      this.$store.dispatch('summery/contactConfig').then((x)=>{
        this.$store.dispatch('summery/info',this.lang).then((x)=>{

        });
        i18n.locale = this.lang;
        if(topic >= 0){
          this.$store.commit('summery/formsetting', this.settings[topic]);
          this.$store.commit('summery/step', 1);
        } else {
            this.$store.commit('summery/step', 0);
        }

        this.$modal.show('contact-email-form')
      });


    },
    closeContactForm: function(){

      this.$modal.hide('contact-email-form')

    }

  }

}
</script>

<style >

.ce-bodytext{
}

.ui.form .field:last-child, .ui.form .fields:last-child .field {
    margin-bottom: 1em;
}

.button{
  border-radius: 0px!important;

}

.ui.input>input {
  padding: .67857143em 0.7em !important;
}

.ui.label {

  padding: 0.4em;
  background-color: #f7f7f7;
}

.ui.tag.label:before, .ui.tag.labels .label:before {

    width: 1.08em;
    height: 1.08em;
}

.ui.tag.label, .ui.tag.labels .label {
    border-radius: 0 .18571429rem .18571429rem 0;
}

a{
  color: #c51a1b;
}
a:hover{
  color: #c51a1b;
  cursor:pointer;
}


.content-top-btn {
    background-color: #c51a1b;
    position: fixed;
    width: 50px;
    height: 50px;
    bottom: 0;
    right: 0;
    z-index: 999;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.large-trikebox{
  height: 100%;
  margin-bottom: 0px;
}

.rcontainer {
  min-height: 190px;
}

.vcomponent{
  min-height: 262px;
  margin-bottom: 20px;
}

.rservices{
  float: right;
}

.listsubmenu{
    margin-bottom: 10px;
    margin-top: 10px;
}

.ad-nr{
  margin-top: 12px;
  text-align: right;
}

.vue-slider-dot {
    z-index: 2!important;
}


@media only screen and (max-width: 1000px) {

  .rcontainer {
    min-height: 0px;
  }
  .rservices{
    float: right;
  }
  .vcomponent{
    min-height: 280px;
  }

}

@media only screen and (max-width: 772px) {
  .rcontainer {
    min-height: 0px;
  }
  .rservices{
    float: left;
    width: 100%;
  }
  .vcomponent{
    min-height: 622px;
  }
  .listsubmenu{
      margin-top: 18px;
  }
  .ad-nr{
    text-align: left;
  }

}


.inset{
  margin-left: 15px;
  margin-right: 15px;
}


@media only screen and (max-width: 410px) {


  .mx-datepicker-popup{
    display: none!important;
  }
/*
  .mx-input{
    pointer-events: none!important;
  }
  */
}

.service-lable {
           color: black;
           font-family: Anton,sans-serif;
           margin-right: 5px;
           font-size: 0.74em;
           letter-spacing: 1px;
           display: inline-block;
           min-width: 96px;
           cursor: auto;
           white-space: nowrap;
           overflow: hidden;
           text-align: left;
           padding-left: 4px;
           text-overflow: ellipsis;
       }

       @media only screen and (max-width: 790px) {
           .ap{
               float:right;
               margin-bottom: 5px;
           }
           .aq{
               text-align: left;
           }
       }

       .ui.icon.input>i.icon {

         width: 1.3em;
       }


       .ui.message {
           position: relative;
           min-height: 1em;
           margin: 1em 0;
           background: #f8f8f9;
           padding: 1em 1.5em;
           line-height: 1.4285em;
           color: rgba(0,0,0,.87);
           -webkit-transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,-webkit-box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease;
           transition: opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease,-webkit-box-shadow .1s ease;
           border-radius: .28571429rem;
           -webkit-box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
           box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 0 0 0 transparent;
       }






</style>
